import type { Middleware, MiddlewareAPI } from "@reduxjs/toolkit";
import { isRejected } from "@reduxjs/toolkit";
import { messageActions } from "../features/message/messageSlice";
import i18n from "../i18n";
//import { setAsyncErrorMessage } from "./apiErrorHandling";

export type LocallyHandledErrors = {
  locallyHandledErrors?: string[];
};

const getLocallyHandledErrors = (arg: unknown): string[] => {
  if (
    arg &&
    typeof arg === "object" &&
    "locallyHandledErrors" in arg &&
    Array.isArray(arg.locallyHandledErrors)
  ) {
    return arg.locallyHandledErrors.filter(
      (handledError): handledError is string =>
        typeof handledError === "string",
    );
  }

  return [];
};

export const errorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    const { setMessage } = messageActions;

    if (isRejected(action)) {
      // 503 is the maintenance signal. The app shell and messaging render that themselves.
      if (action.error?.code === "503") {
        return next(action);
      }

      // Default to "internal_error" if no message

      let errorMessage = action?.error?.message || "internal_error";
      const requestId = action?.meta?.requestId;

      // if the action was rejected with a string, use that as the error message
      // e.g. rejectWithValue("error message")
      if (
        action.meta?.rejectedWithValue &&
        typeof action.payload === "string"
      ) {
        errorMessage = action.payload;
      }
      // console.log("errorLogger", action, errorMessage);
      const locallyHandledErrors = getLocallyHandledErrors(action.meta?.arg);

      if (
        locallyHandledErrors.some((handledError) =>
          errorMessage.includes(handledError),
        )
      ) {
        return next(action);
      }

      // Translate the error message using i18n, with a fallback to the original error message
      const translatedMessage = i18n.exists(`errors:${errorMessage}`)
        ? i18n.t(`errors:${errorMessage}`) + ` ${requestId}`
        : `${errorMessage} ${action?.meta?.requestId}`;

      api.dispatch(
        setMessage({
          text: translatedMessage,
          type: "error",
        }),
      );
      // setAsyncErrorMessage(api.dispatch, {
      //   error: action?.error,
      //   payload: action?.payload,
      //   rejectedWithValue: action.meta?.rejectedWithValue,
      //   requestId: action?.meta?.requestId,
      // });
    }

    return next(action);
  };
